// extracted by mini-css-extract-plugin
export default {"mCard":"Iz-z","image":"Jz-z","imageNoBackground":"Kz-z","imageHasCategory":"Lz-z","fullWidth":"Mz-z"};